import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { FiArrowLeft, FiCalendar, FiEye } from 'react-icons/fi';
import Footer from '../Layout/Footer';

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const { data } = await api.get('/blog');
      setBlogs(data.blogs);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <nav style={styles.nav}>
        <button onClick={() => navigate('/')} style={styles.backBtn}><FiArrowLeft size={18} /> ReplyCraft</button>
        <button onClick={() => navigate('/chat')} style={styles.tryBtn}>Try ReplyCraft</button>
      </nav>

      <div style={styles.container}>
        <h1 style={styles.title}>Blog</h1>
        <p style={styles.subtitle}>Tips on email productivity, communication, and AI tools</p>

        <div style={styles.grid}>
          {blogs.map(blog => (
            <Link key={blog._id} to={`/blog/${blog.slug}`} style={styles.card}>
              <div style={styles.cardBody}>
                <div style={styles.tags}>
                  {blog.tags?.slice(0, 2).map(tag => (
                    <span key={tag} style={styles.tag}>{tag}</span>
                  ))}
                </div>
                <h2 style={styles.cardTitle}>{blog.title}</h2>
                <p style={styles.excerpt}>{blog.excerpt}</p>
                <div style={styles.cardMeta}>
                  <span style={styles.metaItem}><FiCalendar size={12} /> {new Date(blog.publishedAt).toLocaleDateString()}</span>
                  <span style={styles.metaItem}><FiEye size={12} /> {blog.views}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {blogs.length === 0 && !loading && (
          <p style={{ textAlign: 'center', color: 'var(--text-muted)', padding: 60 }}>No blog posts yet. Check back soon!</p>
        )}
      </div>
      <Footer />
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: 'var(--bg-primary)', display: 'flex', flexDirection: 'column' },
  nav: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid var(--border)' },
  backBtn: { display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', color: 'var(--accent)', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  tryBtn: { padding: '8px 20px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  container: { maxWidth: 900, margin: '0 auto', padding: '40px 20px' },
  title: { fontSize: 36, fontWeight: 800, marginBottom: 8 },
  subtitle: { color: 'var(--text-secondary)', fontSize: 16, marginBottom: 40 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 24 },
  card: { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden', textDecoration: 'none', transition: 'border-color 0.2s' },
  cardBody: { padding: 24 },
  tags: { display: 'flex', gap: 6, marginBottom: 12 },
  tag: { padding: '2px 10px', background: 'var(--accent-dim)', color: 'var(--accent)', borderRadius: 12, fontSize: 12, fontWeight: 600 },
  cardTitle: { fontSize: 18, fontWeight: 700, marginBottom: 10, color: 'var(--text-primary)', lineHeight: 1.4 },
  excerpt: { fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 16 },
  cardMeta: { display: 'flex', gap: 16, fontSize: 12, color: 'var(--text-muted)' },
  metaItem: { display: 'flex', alignItems: 'center', gap: 4 }
};
